/**
 * hangingLayout.js — «Протоколы отображения» во вкладке «3D/Кинематика». [12.0.51]
 *
 * Чистый модуль, без DOM и движка. Проводка — ui/sidebarBindings.js.
 *
 * ПОВОД. Список «Протокол» обещал больше, чем делал:
 *   · «Авто (по модальности)» — только тост «протокол определяется
 *     автоматически при загрузке». Это неправда: автоподбор протокола
 *     (viewport.js, applyHangingProtocol) не зовёт никто — проверено поиском;
 *   · «PET-CT → слияние» — ставил раскладку 2×2 без всякого слияния;
 *   · «Свой» — не делал ничего и молчал.
 * Теперь пункты называют ровно то, что произойдёт, «Авто» действительно
 * берёт модальность открытой серии, «Свой» убран.
 *
 * EXPORTS: РАСКЛАДКА_ПО_ПРОТОКОЛУ, РАСКЛАДКА_ПО_МОДАЛЬНОСТИ, раскладкаДляПротокола
 */

/** Явный выбор в списке → раскладка (ключи LAYOUTS из core/viewportState.js). */
export const РАСКЛАДКА_ПО_ПРОТОКОЛУ = Object.freeze({
  'ct-default': 'mpr', 'mr-default': '1x2', 'us-default': '1x1', 'mg-default': '1x2', 'pet-ct': '2x2',
});

/** Модальность DICOM → раскладка для «Авто». */
export const РАСКЛАДКА_ПО_МОДАЛЬНОСТИ = Object.freeze({
  CT: 'mpr', MR: '1x2', US: '1x1', MG: '1x2', PT: '2x2',
});

/**
 * @param {string} протокол — значение списка
 * @param {string|null} модальность — модальность открытой серии
 * @returns {{раскладка:string, пояснение:string}|{раскладка:null, причина:string}}
 */
export function раскладкаДляПротокола(протокол, модальность) {
  if (протокол === 'auto') {
    const м = String(модальность || '').trim().toUpperCase();
    if (!м) return { раскладка: null, причина: 'исследование не открыто — модальность неизвестна' };
    const р = РАСКЛАДКА_ПО_МОДАЛЬНОСТИ[м] || '1x1';
    return { раскладка: р, пояснение: `модальность ${м}` };
  }
  const р = РАСКЛАДКА_ПО_ПРОТОКОЛУ[протокол];
  return р ? { раскладка: р, пояснение: 'выбор в списке' } : { раскладка: null, причина: `неизвестный протокол «${протокол}»` };
}
